/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MallShow_mall$ref = any;
export type MallShowQueryVariables = {||};
export type MallShowQueryResponse = {|
  +mall: ?{|
    +$fragmentRefs: MallShow_mall$ref
  |}
|};
export type MallShowQuery = {|
  variables: MallShowQueryVariables,
  response: MallShowQueryResponse,
|};
*/


/*
query MallShowQuery {
  mall {
    ...MallShow_mall
    id
  }
}

fragment MallShow_mall on Mall {
  name
  phoneNumber
  email
  pdfMapUrl
  address
  shareableHomeUrl
  shareableFlashSaleOffersUrl
  smallMapUrl
  largeMapUrl
  homeUrl
  flashSaleOffersUrl
  mondayOpening
  mondayClosing
  tuesdayOpening
  tuesdayClosing
  wednesdayOpening
  wednesdayClosing
  thursdayOpening
  thursdayClosing
  fridayOpening
  fridayClosing
  saturdayOpening
  saturdayClosing
  sundayOpening
  sundayClosing
}
*/

const node/*: ConcreteRequest*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MallShowQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Mall",
        "kind": "LinkedField",
        "name": "mall",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MallShow_mall"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MallShowQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Mall",
        "kind": "LinkedField",
        "name": "mall",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pdfMapUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "address",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shareableHomeUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shareableFlashSaleOffersUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "smallMapUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "largeMapUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "homeUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flashSaleOffersUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mondayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mondayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tuesdayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tuesdayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wednesdayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wednesdayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thursdayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thursdayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fridayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fridayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "saturdayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "saturdayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sundayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sundayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "MallShowQuery",
    "operationKind": "query",
    "text": "query MallShowQuery {\n  mall {\n    ...MallShow_mall\n    id\n  }\n}\n\nfragment MallShow_mall on Mall {\n  name\n  phoneNumber\n  email\n  pdfMapUrl\n  address\n  shareableHomeUrl\n  shareableFlashSaleOffersUrl\n  smallMapUrl\n  largeMapUrl\n  homeUrl\n  flashSaleOffersUrl\n  mondayOpening\n  mondayClosing\n  tuesdayOpening\n  tuesdayClosing\n  wednesdayOpening\n  wednesdayClosing\n  thursdayOpening\n  thursdayClosing\n  fridayOpening\n  fridayClosing\n  saturdayOpening\n  saturdayClosing\n  sundayOpening\n  sundayClosing\n}\n"
  }
};
// prettier-ignore
(node/*: any*/).hash = '0f6b4d6c1f5266bb09ef0839ebb5171d';

module.exports = node;
